import { render, staticRenderFns } from "./Tab10ParticipantSignaturesRow.vue?vue&type=template&id=6228c83e&scoped=true"
import script from "./Tab10ParticipantSignaturesRow.vue?vue&type=script&lang=js"
export * from "./Tab10ParticipantSignaturesRow.vue?vue&type=script&lang=js"
import style0 from "./Tab10ParticipantSignaturesRow.vue?vue&type=style&index=0&id=6228c83e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228c83e",
  null
  
)

export default component.exports